export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

export const APP_TITLE = "FACE SWITCH";

export const DEBUG_KEY = '97a0a347-90b5-66d7-525f-61fe96ba643d';

export const FEEDBACK_THRESHOLD_SECONDS = 3;